module.exports = __webpack_public_path__ + "img/2.cd28694b.png";